import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dispatch } from "rxjs/internal/observable/pairs";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { onSetFontStylesVisibility, onsetClrPicContext } from "../../../../../../stateManager/store/common/action";
import { getValue, getComponents } from "../../helpers";
import { ColorPicker } from "../ColorPicker";
import { rgbToHex } from "../../../../../marketplace/apps/helpers";

const DEFAULT_BACKGROUND_COLOR: string = "properties.styles.common.backgroundColor";
const DEFAULT_BACKGROUND_COLOR_v3: string = "properties.styles.$deviceType.backgroundColor";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

const excluded_types = [
  "IconInput"
]

export const BackgroundColor = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, computedStyles,isCoreV3, wrapperComputedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];
  const { colorPickerContext } = useSelector((state: any) => state.common);


  const { type } = component;

  const dispatch = useDispatch();
  const setFontStylesVisibility = (visibility : boolean) =>{
    dispatch(onSetFontStylesVisibility(visibility))
  }
  const setColorPickerVisibility = (visibility: boolean) => {
    dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: visibility }))
  };

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_BACKGROUND_COLOR_v3.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue);
        setOldValue(previousValue);
      } else {
        const wrapperStyles = wrapperComputedStyles.hasOwnProperty("backgroundColor") ? wrapperComputedStyles : computedStyles;
        const clr = wrapperStyles && wrapperStyles.backgroundColor
        const rgbaValues = clr?.match(/\d+/g).map(Number) || [];
        let hexColor;
        if (rgbaValues.length === 4) {
          hexColor = rgbToHex(rgbaValues[0], rgbaValues[1], rgbaValues[2], rgbaValues[3]);
        } else if (rgbaValues.length === 3) {
          hexColor = rgbToHex(rgbaValues[0], rgbaValues[1], rgbaValues[2]);
        } else {
          hexColor = null;
        }
        const backgroundColor:any = (wrapperStyles && wrapperStyles.backgroundColor ? hexColor : null);
        setValue(backgroundColor)
        setOldValue(backgroundColor)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_BACKGROUND_COLOR.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue);
        setOldValue(previousValue);
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  if (isCoreV3 && excluded_types.includes(type)) {
    // return null;
  }

  return (
    <ColorPicker
      pickerkey="backgroundColor"
      label="Background"
      value={value}
      open={() => {
        setFontStylesVisibility(false)
        dispatch(onsetClrPicContext({
          value:value,
          placeholder: "",
          where: isCoreV3 ? DEFAULT_BACKGROUND_COLOR_v3 : DEFAULT_BACKGROUND_COLOR,
          visibility:true,
        }))
      }}
      visibility={colorPickerContext?.visibility}
      close={()=>setColorPickerVisibility(false)}
    />
  )
};
